<script>
  export let source;
  export let alt = "";
  export let shareable = false;
  export let width_percent;
  export let zoomable = true;

  import { zooming, ci } from "../store.js";
  import { toast } from "@zerodevx/svelte-toast";

  const linkText = $ci.strings.copy_link ?? "🔗 Link zum Bild kopieren";

  const style = "--width: " + (width_percent ? width_percent + "%" : "auto");

  import { onMount } from "svelte";
  onMount(() => $zooming.listen(".locked-img.zoomable"));

  let el;

  // https://stackoverflow.com/a/30810322/8833247
  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      const fallbackCopyTextToClipboard = (text) => {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand("copy");
          var msg = successful ? "successful" : "unsuccessful";
          toast.push("Link kopiert.");
        } catch (err) {
          toast.push("Konnte den Link nicht kopieren.");
        }

        document.body.removeChild(textArea);
      };
      fallbackCopyTextToClipboard(text);
      return;
    }

    navigator.clipboard.writeText(text).then(
      function () {
        toast.push("Link kopiert.");
      },
      function (err) {
        toast.push("Konnte den Link nicht kopieren.");
      }
    );
  }

  function getImageLink(src) {
    var pat = /^https?:\/\//i;
    if (pat.test(src)) {
      // absolute
      return src;
    } else {
      let loc = window.location;
      return `${loc.protocol}//${loc.hostname}${
        loc.port !== "" ? `:${loc.port}` : ""
      }/${src}`;
    }
  }
</script>

<div class="locked-img-container" {style}>
  <img class="locked-img" class:zoomable src={source} {alt} />
  <!-- svelte-ignore a11y-missing-attribute -->
  {#if shareable}<a
      class="locked-img-share-link"
      role="button"
      bind:this={el}
      on:click={copyTextToClipboard(getImageLink(source))}>{linkText}</a
    >{/if}
</div>

<style>
  .locked-img-container {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: unset;
    width: var(--width, unset);
  }

  .locked-img {
    width: 100%;
  }

  .locked-img-share-link {
    display: block;
    align-self: flex-end;
    cursor: pointer;
    font-size: 0.9rem;
  }

  /*
  @media (min-width: 640px) {
    .locked-img {
      width: auto;
    }
  }*/
</style>
